import { useEffect, useMemo, useState } from "react"
import {
  getAllCities,
  getAllStates,
  getCountries,
} from "../../Utils/hooks/location"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import useLocalStorageState from "use-local-storage-state"
import { ContactHeader } from "./ContactModule/ContactHeader"
import { ContactForm } from "./ContactModule/ContactForm"
import { fetchTemporaryFilterData } from "../../Utils/helpers/commonhelper"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard"
import { ContactListing } from "./ContactListing"
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials"
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue"

export const Contacts = () => {

  // getting essentials for apis
  const { headers, extras, customerId, loginUserId, userType } = useGetEssentials()
  // parsing contacts metadata object
  const contactsMetadata = JSON.parse(localStorage.getItem('contactsMetadata'))

  //start column visibility setting
  const columnOptions = [
    { id: "serial", label: "#", mandatory: true },
    { id: "name", label: "Name", mandatory: true },
    { id: "email", label: "Email" },
    { id: "mobile", label: "Mobile" },
    { id: "owner", label: "Owner" },
    { id: "report_to", label: "Report To" },
    { id: "company", label: "Company Name" },
    { id: "designation", label: "Designation" },
    { id: "department", label: "Department" },
    { id: "decision", label: "Decision Maker" },
    { id: "city", label: "City" },
    { id: "state", label: "State" },
    { id: "country", label: "Country" },
    { id: "zipcode", label: "Zipcode" },
    { id: "source", label: "Lead Source" },
    { id: "tags", label: "Tags" },
    { id: "notes", label: "Notes" },
  ]

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([])

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = contactsMetadata?.visibleColumns
    const allColumns = columnOptions.map(col => col.label);

    if (saved) {
      try {
        return saved;
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }

    // Default: all columns visible
    return allColumns;
  });

  // state for heading to display
  // const lastHeading = localStorage.getItem("last_heading")
  const [heading, setHeading] = useState("All Contacts")

  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (!isInitialized) {
      const lastHeading = contactsMetadata?.filterType?.filterName;
      setHeading(lastHeading || "All Contacts")
      setIsInitialized(true)
    }
  }, [isInitialized, contactsMetadata])

  // rbac permission object
  const [PERMISSION, _] = useLocalStorageState('permission')
  const contactGrant = PERMISSION.contact;
  // general states 2
  const [showCards, setShowCards] = useState(false)
  // states to store the filter data
  const [filterStates, setFilterState] = useState([])

  const [contactFilterDataParams, setContactFilterDataParams] = useGlobalState('contactFilterDataParams', { currAdvFilter: null, applyFilterData: {} })

  // loading state for temporary filter data to be hydrated
  const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false)
  // curr advance filter to store the current filter type between "apply" and "save as" in advance filter for respective pagination in apply filter
  const [currAdvFilter, setCurrAdvFilter] = useState(contactFilterDataParams?.currAdvFilter || null)

  // state for filter dropdown contacts
  const [filterDropdown, setFilterDropdown] = useState(false)
  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null)

  // global value state for applying the pagination to temporary filter data
  const [contactFilterValues, setContactFilterValues] = useGlobalState("contactApplyFilterQueryValues")

  // default curr view change to list
  const [currView, setCurrView] = useState(() => {
    return contactsMetadata?.currView || "list"
  })
  // for offcanvas
  const [show, setShow] = useState(false)
  // country state
  const [country, setCountries] = useState([])
  // all states for filter field hydration
  const [allState, setAllState] = useState([])
  // all cities for filter field hydration
  const [allCity, setAllCity] = useState([])

  // all contacts state to pass to the custom fields if field included
  const [allContacts, setAllContacts] = useState([])

  // state that will hold the contacts listing data
  const [contactsData, setContactsData] = useState(null)

  // state to store the advanced custom filter to fetch data on save
  const [customFilter, setCustomFilter] = useState(null)

  // common advance filter api calls that will be needed everywhere
  const { leadOwner, lead_source, company } = useCommonData({
    leadOwner: true,
    leadSource: true,
    companies: true,
    contacts: false
  })

  // advanced filtering states
  const dropdownOptions = [
    { value: "first_name", label: "FirstName" },
    { value: "last_name", label: "LastName" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Phone" },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "report_to", label: "Report To" },
    { value: "visible_to", label: "Visible To", option: leadOwner },
    { value: "company_id", label: "Company Name", option: company },
    { value: "designation", label: "Designation" },
    { value: "department", label: "Department" },
    { value: "decision_maker", label: "Decision Maker" },
    { value: "city", label: "City", option: allCity },
    { value: "state", label: "State", option: allState },
    { value: "country", label: "Country", option: country },
    { value: "zipcode", label: "Zipcode" },
    { value: "lead_source_id", label: "Lead Source", option: lead_source },
    { value: "tag", label: "Tags" },
    { value: "note", label: "Notes" },
    { value: "created_at", label: "Created at", type: "date-range" },
    { value: "added_by", label: "Created By", option: leadOwner },
  ]

  // States for using pagination
  const [listLimit, setListLimit] = useState(25)
  const [cardLimit, setCardLimit] = useState(20)

  const limit = currView === "card" ? cardLimit : listLimit
  const setLimit = currView === "card" ? setCardLimit : setListLimit

  const [listOffset, setListOffset] = useState(0)
  const [cardOffset, setCardOffset] = useState(0)

  const activeOffset = currView === "card" ? cardOffset : listOffset
  const setActiveOffset = (value) => {

    currView === "card" ? setCardOffset(value) : setListOffset(value)
  }
  const [search, setSearch] = useState("")

  const params = {
    limit,
    offset: activeOffset,
    search,
  }

  const applyFilterDataParams = {
    filterValues: contactFilterValues,
    currView: currView,
    offset: activeOffset,
    limit: limit,
    module_name: 'contacts',
    customerId: customerId,
    loginUserId: loginUserId,
    userType: userType,
    headers: headers,
    extras: extras,
    setTempFilterData: setTempFilterData,
    setLoading: setTempFilterDataLoading,
    setFilterState: setFilterState,
    setFilterDropdown: setFilterDropdown
  }

  useEffect(() => {
    setContactFilterDataParams({
      currAdvFilter: currAdvFilter,
      applyFilterData: {
        ...applyFilterDataParams,
        filterValues: contactFilterValues,
        currView: currView,
        offset: activeOffset,
        limit: limit,
      }
    })
  }, [currAdvFilter, contactFilterValues, currView, activeOffset, limit])

  // Save view preference to localStorage
  useEffect(() => {
    localStorage.setItem("contactsMetadata", JSON.stringify(
      {
        ...contactsMetadata,
        currView: currView,
      }
    ))
  }, [currView])

  //  allFstate for filter hydration
  const fetchAllStatesData = async () => {
    try {
      const data = await getAllStates()
      if (!data || data === undefined) {
        setAllState([])
        return
      }
      setAllState(
        data.map((state) => ({
          label: state.state_name,
          value: state.id,
        }))
      )
    } catch (error) {
      //shoservererror()()
      return
    }
  }

  // allcity useeffect for filter hydration
  const fetchAllCitiesData = async () => {
    try {
      const data = await getAllCities()
      if (!data || data === undefined) {
        setAllCity([])
        return
      }
      setAllCity(
        data.map((city) => ({
          label: city.city_name,
          value: city.id,
        }))
      )
    } catch (error) {
      //shoservererror()()
      return
    }
  }

  // useeffect for country
  const fetchCountriesData = async () => {
    try {
      const data = await getCountries()
      if (!data) return
      setCountries(
        data.map((country) => ({
          label: country.name,
          value: country.id,
        }))
      )
    } catch (error) {
      //shoservererror()()
      return
    }
  }

  // running all requests parallely
  const initData = async () => {
    await Promise.all([
      fetchCountriesData(),
      fetchAllStatesData(),
      fetchAllCitiesData(),
    ])
  }
  useEffect(() => {
    initData()
  }, [])

  useEffect(() => {
    if (currAdvFilter === "apply" && contactFilterValues?.["filter_values"]?.length > 0) {
      fetchTemporaryFilterData(contactFilterDataParams?.applyFilterData)
      // setFilterState(contactFilterValues?.["filter_state"])
      // setFilterDropdown(false)
    }
  }, [contactFilterDataParams?.applyFilterData])

  const { endpoint, queryKey } = useMemo(() => {
    if (currAdvFilter === "apply") {
      return {
        endpoint: "",
        queryKey: ""
      }
    }
    // reseting the state if current advance filter is null
    setContactFilterValues({ filter_state: [], filter_values: [] })
    // éxtracting customfilter id for the last custom filter if created
    const customFilterId = contactsMetadata?.filterType?.id;
    // fetching contacts based on header
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading
    if (!customFilter && !customFilterId) {
      if (lowerHeading === "contacts_created_by_me") {
        return {
          endpoint: `contacts/getContactsCreatedByMe/${loginUserId}/${customerId}/${userType}`,
          queryKey: "contactsCreatedByMe"
        }
      }
      if (lowerHeading === "contacts_created_today") {
        return {
          endpoint: `contacts/getContactsCreatedBasedOnDuration/${loginUserId}/${customerId}/today/${userType}`,
          queryKey: "contactsCreatedToday"
        }
      }
      if (lowerHeading === "contacts_created_this_month") {
        return {
          endpoint: `contacts/getContactsCreatedBasedOnDuration/${loginUserId}/${customerId}/month/${userType}`,
          queryKey: "contactsCreatedThisMonth"
        }
      }
      if (lowerHeading === "all_contacts") {
        return {
          endpoint: `contacts/fetchAllContacts/${loginUserId}/${customerId}/${userType}`,
          queryKey: "fetchAllContacts"
        }
      }
    }
    if (customFilter || customFilterId) {

      const id = customFilter?.id || customFilterId
      return {
        endpoint: `contacts/fetchAllContacts/${loginUserId}/${customerId}/${userType}/${id}`,
        queryKey:
          `filterQuery${id}`
      }
    }
    return {
      endpoint: "",
      queryKey: ""
    }
  }, [
    heading,
    filterCategories,
    // contactsMetadata?.filterType?.id,
    currAdvFilter,
    customFilter,
  ])

  // contact data fetching request based on endpoint and querykey
  const { data, error, refetch, isLoading } = useGetRequest(
    endpoint,
    queryKey,
    headers,
    extras,
    params
  )

  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {

    if (currAdvFilter === 'apply') return

    if (
      data &&
      data.filter_data &&
      data.filter_data[0] &&
      data.filter_data[0].filter_values
    ) {
      const values = data.filter_data[0].filter_values
      const parsedState = JSON.parse(values)
      const filteredArray = parsedState?.map((state) => {
        // Find the corresponding dropdown option to get the display label and potential nested options
        const dropdownValue = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        )
        // const mappedOptions = getMappedOptionValue(dropdownOption)

        return {
          id: state.label_name, // IMPORTANT: Generate a new unique ID for React keys
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownValue ? dropdownValue.label : state.label_name,
          option: dropdownValue.option,
          subFilterType: state.label_query,
          value: state.label_value,
        }
      })
      setFilterState(filteredArray)
    } else {
      setFilterState([])
    }

    if (queryKey === "fetchAllContacts" && data?.data) {
      const contactsData = data.data.map((contact) => ({
        contact_id: contact.id,
        contact_name: contact.contact_full_name,
      }))
      setAllContacts(contactsData)
    }
    setContactsData(data?.data)
  }, [queryKey, data, currAdvFilter])

  // if no permission for module then authorization card
  if (!contactGrant.isView) {
    return <div style={{ position: "absolute", left: "40%", top: "10rem" }}>
      <AuthorizationCard />
    </div>
  }

  return (
    <div className="d-flex flex-column  w-100">
      <ContactHeader
        heading={heading}
        setHeading={setHeading}
        // lastHeading={lastHeading}
        showCards={showCards}
        setShowCards={setShowCards}
        setSearch={setSearch}
        currView={currView}
        setActiveOffset={setActiveOffset}
        setCurrView={setCurrView}
        dropdownOptions={dropdownOptions}
        filterStates={filterStates}
        setFilterState={setFilterState}
        filterCategories={filterCategories}
        setFilterCategories={setFilterCategories}
        columnOptions={columnOptions}
        columns={columns}
        setColumns={setColumns}
        // contactGrants={contactGrants}
        setShow={setShow}
        setTempFilterData={setTempFilterData}
        setCurrAdvFilter={setCurrAdvFilter}
        refetch={refetch}
        setCustomFilter={setCustomFilter}
        contactsMetadata={contactsMetadata}
        filterDropdown={filterDropdown}
        setFilterDropdown={setFilterDropdown}
        filterValues={contactFilterValues?.filter_state}
        setContactFilterValues={setContactFilterValues}
      />

      <ContactForm
        show={show}
        setShow={setShow}
        // companyGrants={companyGrants}
        refetch={refetch}
        country={country}
        allContacts={allContacts}
      // masterGrant={masterGrant}
      />


      <ContactListing
        isInitialized={isInitialized}
        columns={columns}
        limit={limit}
        filterData={tempFilterData}
        totalContacts={data?.total_count}
        setLimit={setLimit}
        currView={currView}
        data={contactsData}
        error={error}
        isLoading={isLoading || tempFilterDataLoading}
        queryKey={queryKey}
        setOffset={setActiveOffset}
        offset={activeOffset}
        headers={headers}
        visibleColumns={columns}
        allContactData={allContacts}
        refetch={refetch}
      ></ContactListing>
    </div >
  );
};